module.exports = __webpack_public_path__ + "static/img/企业微信体系.2e0649c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/企业微信体系.png
// module id = DjfX
// module chunks = 0